import { apiClient } from '@features/shared/api/client'
import { normalizeViewConfig, toBackendCreateView, toBackendUpdateView } from './normalizers'
import type { CreateViewRequest, UpdateViewRequest, ViewConfig } from '../models'
import type { ListViewsResponse, ViewDetail } from './contracts'
import type { Column } from '@features/columns/models'

export async function getViews(tableId: string): Promise<ViewConfig[]> {
  const { data } = await apiClient.get<ListViewsResponse>(`/tables/${tableId}/views`)
  return data.views.map(normalizeViewConfig)
}

export async function getView(tableId: string, viewId: string): Promise<ViewConfig> {
  const { data } = await apiClient.get<ViewDetail>(`/tables/${tableId}/views/${viewId}/meta`)
  return normalizeViewConfig(data)
}

export async function createView(
  tableId: string,
  payload: CreateViewRequest,
  options?: { is_temp?: boolean; origin_view_id?: string | null; session_id?: string | null },
  columns?: Column[]
): Promise<ViewConfig> {
  const body = toBackendCreateView(payload, options, columns)
  const { data } = await apiClient.post<ViewDetail>(`/tables/${tableId}/views`, body)
  return normalizeViewConfig(data)
}

export async function updateView(
  tableId: string,
  viewId: string,
  payload: UpdateViewRequest,
  columns?: Column[]
): Promise<ViewConfig> {
  const body = toBackendUpdateView(payload, columns)
  const { data } = await apiClient.put<ViewDetail>(`/tables/${tableId}/views/${viewId}`, body)
  return normalizeViewConfig(data)
}

export async function deleteView(tableId: string, viewId: string): Promise<void> {
  await apiClient.delete(`/tables/${tableId}/views/${viewId}`)
}
